import { EpochInfo as youtubismEpochInfo, events as youtubismEvents, ambassador as youtubismAmbassador } from "./MuseumData/YOUTUBISM/YoutubismData";
import { EpochInfo as instagraminismEpochInfo, events as instagraminismEvents, ambassador as instagraminismAmbassador } from "./MuseumData/INSTAGRAMINISM/InstagraminismData";
import { EpochInfo as facebookEpochInfo, events as facebookEvents, ambassador as facebookAmbassador } from "./MuseumData/FACEBOOK/FacebookData";
import { EpochInfo as riseOfBloggingInfo, events as riseOfBloggingEvents, ambassador as riseOfBloggingAmbassador } from "./MuseumData/RiseOfBlogging/RiseOfBlogging";
import { EpochInfo as wordpressismInfo, events as wordpressismEvents, ambassador as wordpressismAmbassador } from "./MuseumData/Wordpressism/Wordpressism";
import { EpochInfo as mySpacismInfo, events as mySpacismEvents, ambassador as mySpacismAmbassador } from "./MuseumData/MySpacism/MySpacism";
import { EpochInfo as twittArtInfo, events as twittArtEvents, ambassador as twittArtAmbassador } from "./MuseumData/TwittArt/TwittArt";
import { EpochInfo as twitchArtInfo, events as twitchArtEvents, ambassador as twitchArtAmbassador } from "./MuseumData/TwitchArt/TwitchArt";
import { EpochInfo as tiktokkoInfo, events as tiktokkoEvents, ambassador as tiktokkoAmbassador } from "./MuseumData/Tiktokko/Tiktokko";


export const epochs = [
  {
    title: "RISE OF BLOGGING",
    period: "1994-2004",
    color: "#F0B849",
    events: [
      { year: "986", title: "The Pillow Book"},
      { year: "1520", title: "Der Kleidernarr"},
      { year: "1994", title: "Founding Father"},
      { year: "1997", title: "Weblog formula"},
      { year: "1998", title: "Career Hurricane"},
      { year: "1999", title: "Blogiverse Is No Joke"},
      { year: "2000", title: "Catalog"},
      { year: "2000", title: "Journey to Los Angeles"},
      { year: "2000", title: "Who Invented Vlogging?"}
    ]
  },
  {
    title: "WORDPRESSISM",
    period: "1999-2004",
    color: "#21759B",
    events: [
      { year: "1998", title: "Open Diary. Open up opportunities" },
      { year: "1999", title: "The Big Three is Born" },
      { year: "2001", title: "Is there a price tag on freedom of speech?" },
      { year: "2003", title: "WordPressism" },
      { year: "2004", title: "Word of the Year" }
    ]
  },
  {
    title: "MYSPACISM",
    period: "2003-2008",
    color: "#039",
    events: [
      { year: "2003", title: "Jeffrey Starr’s Blog" },
      { year: "2004", title: "Ascent to Orbit" },
      { year: "2004", title: "The Largest Advertising Integration" },
      { year: "2005", title: "Myspace Tom" },
      { year: "2006", title: "Life-Changing Viral Video" },
    ]
  },
  {
    title: "FACEBOOK ART",
    period: "2004-present",
    color: "#1877F2",
    events: [
      { year: "2004", title: "Harvard Life" },
      { year: "2007", title: "Page After Page" },
      { year: "2014", title: "The Advent of Algorithms" },
      { year: "2015", title: "The Power of Celebrities" },
      { year: "2018", title: "Maherco Gaming" },
      { year: "2021", title: "Flight from Twitch" },
      { year: "2021", title: "Going Beyond Reality" }
    ]
  },
  {
    title: youtubismEpochInfo.title,
    period: "2005-present",
    color: "#F00",
    events: youtubismEvents
  },
  {
    title: "TWITT ART",
    period: "2006-present",
    color: "#1DA1F2",
    events: [
      { year: "2006", title: "My twttr" },
      { year: "2006", title: "Blogger Robert Scoble" },
      { year: "2007", title: "#hashtag" },
      { year: "2008", title: "@BarackObama" },
      { year: "2009", title: "Ashton Kutcher Beats CNN" },
      { year: "2012", title: "Mean Tweets" },
      { year: "2015", title: "#TheDress" },
      { year: "2016", title: "Graveyard of Platforms That Didn’t Make It" },
      { year: "2016", title: "Blue Check Mark" },
      { year: "2017", title: "‘What’s a Thread?’ Thread" },
      { year: "2019", title: "The Most Generous Blogger on Twitter" },
      { year: "2020", title: "Donald Trump’s Account Ban" },
      { year: "2022", title: "Elon Musk: How Do You Like It?" },
      { year: "2023", title: "What the X?!" }
    ]
  },
  {
    title: "INSTAGRAMINISM",
    period: "2010-present",
    color: "#E1306C",
    events: [
      { year: "2010", title: "Who was first?" },
      { year: "2013", title: "Oscar-Winning Selfie" },
      { year: "2013-2014", title: "Selfie Revolution" },
      { year: "2014", title: "Belfie" },
      { year: "2014", title: "We’re All Sick!" },
      { year: "2015", title: "Selfie Rock Star" },
      { year: "2015-2016", title: "#FAKE" },
      { year: "2019", title: "The Story of an Egg Named Eugene" },
      { year: "2023", title: "TOP 40" },
      { year: "2023", title: "$1 600 000" },
      { year: "2023", title: "#FollowMeTo" },
      { year: "2023-2024", title: "Threads: The Chat That Never Ends" }
    ]
  },
  {
    title: "TWITCH ART",
    period: "2011-present",
    color: "#9146FF",
    events: [
      { year: "2011", title: "Twitch Gameplay" },
      { year: "2011-2023", title: "The Fastest Mario" },
      { year: "2015", title: "TwitchCon" },
      { year: "2017", title: "Record-Breaking Crowd" },
      { year: "2017", title: "Expanded Features" },
      { year: "2018", title: "Ninja vs. Drake" },
      { year: "2018", title: "Record Collector" },
      { year: "2019", title: "Just Chatting" },
      { year: "2020", title: "COVID Boost" },
      { year: "2020", title: "Disguised Toast" },
      { year: "2020", title: "Kappa Emote" },
      { year: "2023", title: "The Endless Story" }
    ]
  },
  {
    title: "TIKTOKKO",
    period: "2016-present",
    color: "#31E0DD",
    events: [
      { year: "2016", title: "How It All Started: Musical.ly" },
      { year: "2018", title: "We Are in Our TikTok Era" },
      { year: "2019", title: "The First Content House" },
      { year: "2020", title: "Charli D'Amelio" },
      { year: "2020", title: "POV: The Term That Is a Must to Understand the Context" },
      { year: "2020", title: "The Best of the Best: Bella Poarch and Khaby Lame" },
      { year: "2021", title: "#BookTok" },
      { year: "2022", title: "For You Page or How TikTok is Becoming a Gen Z Subculture" },
      { year: "2023", title: "Ban Alert" },
      { year: "2024", title: "TikTok's Album Party" }
    ]
  }
];

export const epochsData: Record<string, { info: any; events: any[]; ambassador: any }> = {
  youtubism: {
    info: youtubismEpochInfo,
    events: youtubismEvents,
    ambassador: youtubismAmbassador
  },
  instagraminism: {
    info: instagraminismEpochInfo,
    events: instagraminismEvents,
    ambassador: instagraminismAmbassador
  },
  facebook_art: {
    info: facebookEpochInfo,
    events: facebookEvents,
    ambassador: facebookAmbassador
  },
  rise_of_blogging: {
    info: riseOfBloggingInfo,
    events: riseOfBloggingEvents,
    ambassador: riseOfBloggingAmbassador
  },
  wordpressism: {
    info: wordpressismInfo,
    events: wordpressismEvents,
    ambassador: wordpressismAmbassador
  },
  myspacism: {
    info: mySpacismInfo,
    events: mySpacismEvents,
    ambassador: mySpacismAmbassador,
  },
  twitt_art: {
    info: twittArtInfo,
    events: twittArtEvents,
    ambassador: twittArtAmbassador,
  },
  twitch_art: {
    info: twitchArtInfo,
    events: twitchArtEvents,
    ambassador: twitchArtAmbassador,
  },
  tiktokko: {
    info: tiktokkoInfo,
    events: tiktokkoEvents,
    ambassador: tiktokkoAmbassador,
  },
}
